import React, { useEffect, useMemo, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import { getRegs, insert, oikosGet, update } from '../../../utils/fc'
import { notifyError, notifyInfo, notifySuccess } from '../../../utils/notify'
import './Atividades.css'

const LOCAIS = ['Homeoffice', 'Campo', 'Ecossis', 'Cliente']
const UNIDADES_ORDEM = [6, 1, 2]
const ROTULO_QTD = {
  6: 'Quantos Minutos?',
  1: 'Quantas Horas?',
  2: 'Quantos Dias?',
}
const NOME_UNIDADE = {
  6: ['minuto', 'minutos'],
  1: ['hora', 'horas'],
  2: ['dia', 'dias'],
}

const FORM_INICIAL = {
  atividade_nome: '',
  proj_id: '',
  prod_id: '',
  pf_id: '',
  setorAtiv_id: '',
  unidade_id: '',
  atividade_unidadeQtd: '',
  dtIniPlanejada: null,
  dtFimPlanejada: null,
  dtIniReal: null,
  dtFimReal: null,
  atividade_local: '',
  atividadeStatus_id: '1',
  atividade_coment: '',
}

function listaDe(resposta) {
  const corpo = resposta && resposta.data
  return Array.isArray(corpo) ? corpo : []
}

async function listar(table, data = {}) {
  const resposta = await oikosGet({ action: 'get', table, data })
  return listaDe(resposta)
}

function isoDeData(data) {
  if (!data) return ''
  const d = data instanceof Date ? data : new Date(data)
  if (Number.isNaN(d.getTime())) return ''
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const dia = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mes}-${dia}`
}

function dataDeIso(valor) {
  const iso = diaIso(valor)
  if (!iso) return null
  const [ano, mes, dia] = iso.split('-').map(Number)
  return new Date(ano, mes - 1, dia)
}

function diaIso(valor) {
  if (!valor) return ''
  const texto = String(valor).slice(0, 10)
  return /^\d{4}-\d{2}-\d{2}$/.test(texto) ? texto : ''
}

function hojeIso() {
  return isoDeData(new Date())
}

function inicioDaSemana(data) {
  const d = new Date(data.getFullYear(), data.getMonth(), data.getDate())
  const dia = d.getDay()
  const diff = dia === 0 ? -6 : 1 - dia
  d.setDate(d.getDate() + diff)
  return d
}

function formatarIso(valor) {
  const iso = diaIso(valor)
  if (!iso) return ''
  const [ano, mes, dia] = iso.split('-')
  return `${dia}/${mes}/${ano}`
}

function rotuloMes(chave) {
  const [ano, mes] = chave.split('-').map(Number)
  const nome = new Date(ano, mes - 1, 1).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })
  return nome.charAt(0).toUpperCase() + nome.slice(1)
}

function nomePessoa(pessoa) {
  if (!pessoa) return ''
  if (pessoa.pf_nomeExibicao) return pessoa.pf_nomeExibicao
  return [pessoa.pf_nome, pessoa.pf_sobrenome].filter(Boolean).join(' ')
}

function equipeNaData(linha, hoje) {
  const ini = diaIso(linha.projEquipe_ini)
  const fim = diaIso(linha.projEquipe_fim)
  if (ini && ini > hoje) return false
  if (fim && fim < hoje) return false
  return true
}

function mesmoId(a, b) {
  return String(a) === String(b)
}

function rotuloQuantidade(unidadeId, quantidade) {
  const par = NOME_UNIDADE[Number(unidadeId)]
  if (!par || quantidade === '' || quantidade == null) return ''
  const n = Number(quantidade)
  return `${n} ${n === 1 ? par[0] : par[1]}`
}

function Afazer({ nomeInicial, concluida, onConcluir, onRenomear, onExcluir }) {
  const [editando, setEditando] = useState(false)
  const [rascunho, setRascunho] = useState(nomeInicial || '')
  const cancelar = useRef(false)

  async function gravarNome() {
    if (cancelar.current) {
      cancelar.current = false
      setRascunho(nomeInicial || '')
      setEditando(false)
      return
    }
    const texto = rascunho.trim()
    if (!texto || texto === (nomeInicial || '')) {
      setRascunho(nomeInicial || '')
      setEditando(false)
      return
    }
    const ok = await onRenomear(texto)
    if (ok !== false) setEditando(false)
  }

  return (
    <div className={`ativ-tarefa${concluida ? ' concluida' : ''}`}>
      {onConcluir ? (
        <input
          type="checkbox"
          checked={Boolean(concluida)}
          onChange={onConcluir}
          aria-label={concluida ? 'Desmarcar afazer' : 'Concluir afazer'}
        />
      ) : <span className="ativ-tarefa-marca" aria-hidden="true" />}
      {editando ? (
        <input
          type="text"
          className="ativ-tarefa-nome"
          value={rascunho}
          autoFocus
          aria-label="Nome do afazer"
          onChange={event => setRascunho(event.target.value)}
          onBlur={gravarNome}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.preventDefault()
              event.currentTarget.blur()
            }
            if (event.key === 'Escape') {
              cancelar.current = true
              event.currentTarget.blur()
            }
          }}
        />
      ) : (
        <button type="button" className="ativ-tarefa-nome" onClick={() => { setRascunho(nomeInicial || ''); setEditando(true) }}>
          {nomeInicial}
        </button>
      )}
      <button type="button" className="ativ-tarefa-excluir" aria-label="Excluir afazer" onClick={onExcluir}>×</button>
    </div>
  )
}

export function ListaTarefas({ tarefas, pendentes, onAdicionar, onConcluir, onRenomear, onExcluir, onRenomearPendente, onExcluirPendente, recolhivel, ocultarTitulo }) {
  const [nome, setNome] = useState('')
  const [aberto, setAberto] = useState(!recolhivel)
  const itens = tarefas || []
  const extras = pendentes || []

  async function incluir(event) {
    event.preventDefault()
    event.stopPropagation()
    const texto = nome.trim()
    if (!texto) return
    const ok = await onAdicionar(texto)
    if (ok !== false) setNome('')
  }

  const corpo = (
    <div className="ativ-tarefas-corpo" onClick={event => event.stopPropagation()}>
      {itens.map(tarefa => (
        <Afazer
          key={tarefa.todo_id}
          nomeInicial={tarefa.todo_nome}
          concluida={Boolean(Number(tarefa.todo_concluida))}
          onConcluir={() => onConcluir(tarefa)}
          onRenomear={texto => onRenomear(tarefa, texto)}
          onExcluir={() => onExcluir(tarefa)}
        />
      ))}
      {extras.map((texto, indice) => (
        <Afazer
          key={`pendente-${indice}-${texto}`}
          nomeInicial={texto}
          onRenomear={novo => onRenomearPendente(indice, novo)}
          onExcluir={() => onExcluirPendente(indice)}
        />
      ))}
      {!itens.length && !extras.length && <p className="ativ-vazio">Nenhuma tarefa.</p>}
      <form className="ativ-tarefa-nova" onSubmit={incluir}>
        <input
          type="text"
          value={nome}
          placeholder="Nova tarefa"
          onChange={event => setNome(event.target.value)}
        />
        <button type="submit" className="ativ-btn ativ-btn-secundario ativ-mais" aria-label="Adicionar tarefa">+</button>
      </form>
    </div>
  )

  if (!recolhivel) {
    return (
      <div className="ativ-tarefas">
        {!ocultarTitulo && <p className="ativ-tarefas-titulo">Tarefas</p>}
        {corpo}
      </div>
    )
  }

  return (
    <div className="ativ-tarefas">
      <button type="button" className="ativ-tarefas-titulo" aria-expanded={aberto} onClick={event => { event.stopPropagation(); setAberto(valor => !valor) }}>
        Tarefas
      </button>
      {aberto && corpo}
    </div>
  )
}

export default function Atividades() {
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro] = useState('')
  const [projetos, setProjetos] = useState([])
  const [produtos, setProdutos] = useState([])
  const [pessoas, setPessoas] = useState([])
  const [equipe, setEquipe] = useState([])
  const [atividades, setAtividades] = useState([])
  const [todos, setTodos] = useState([])
  const [tarefasPendentes, setTarefasPendentes] = useState([])
  const [naturezas, setNaturezas] = useState([])
  const [statusLista, setStatusLista] = useState([])
  const [unidades, setUnidades] = useState([])
  const [filtroPf, setFiltroPf] = useState('')
  const [filtroMes, setFiltroMes] = useState('')
  const [filtroTipo, setFiltroTipo] = useState('')
  const [filtroStatus, setFiltroStatus] = useState('')
  const [somenteSemana, setSomenteSemana] = useState(true)
  const [alvo, setAlvo] = useState(null)
  const [travado, setTravado] = useState(false)
  const [detalhesAbertos, setDetalhesAbertos] = useState(() => new Set())
  const [modalAberto, setModalAberto] = useState(false)
  const [form, setForm] = useState(FORM_INICIAL)
  const [avisoForm, setAvisoForm] = useState('')
  const [salvando, setSalvando] = useState(false)

  const semanaIni = useMemo(() => inicioDaSemana(new Date()), [])
  const semanaFim = useMemo(() => {
    const d = new Date(semanaIni)
    d.setDate(d.getDate() + 6)
    return d
  }, [semanaIni])
  const semanaIniIso = isoDeData(semanaIni)
  const semanaFimIso = isoDeData(semanaFim)

  useEffect(() => {
    let vivo = true
    async function carregar() {
      try {
        const [proj, prod, pf, eq, ativ, setoresAtiv, statusAtiv, unid, listaTodo] = await Promise.all([
          getRegs('proj', { proj_ativo: 1 }),
          getRegs('prod', { prod_ativo: 1 }),
          getRegs('pf', { dpto_id: 4 }),
          getRegs('projEquipe', { projEquipe_ativo: 1 }),
          listar('atividade'),
          getRegs('setorAtiv'),
          listar('atividadeStatus'),
          listar('unidade'),
          getRegs('todo', { todo_tabRef: 'atividade' }),
        ])
        if (!vivo) return
        const hoje = hojeIso()
        setProjetos(Array.isArray(proj) ? proj : [])
        setProdutos(Array.isArray(prod) ? prod : [])
        setPessoas(Array.isArray(pf) ? pf : [])
        setEquipe((Array.isArray(eq) ? eq : []).filter(linha => equipeNaData(linha, hoje)))
        setAtividades((Array.isArray(ativ) ? ativ : []).filter(item => Number(item.atividade_ativo) !== 0))
        setTodos(Array.isArray(listaTodo) ? listaTodo : [])
        setNaturezas((Array.isArray(setoresAtiv) ? setoresAtiv : []).filter(item => [6, 9].includes(Number(item.setor_id))))
        setStatusLista(statusAtiv)
        setUnidades(unid.filter(item => UNIDADES_ORDEM.includes(Number(item.unidade_id))))
      } catch (e) {
        if (vivo) setErro('Não foi possível carregar as atividades.')
      } finally {
        if (vivo) setCarregando(false)
      }
    }
    carregar()
    return () => { vivo = false }
  }, [])

  const produtoPorId = useMemo(() => {
    const mapa = new Map()
    produtos.forEach(produto => mapa.set(String(produto.prod_id), produto))
    return mapa
  }, [produtos])

  const projetoPorId = useMemo(() => {
    const mapa = new Map()
    projetos.forEach(projeto => mapa.set(String(projeto.proj_id), projeto))
    return mapa
  }, [projetos])

  function naEquipe(pfId, projId) {
    if (!pfId || !projId) return false
    return equipe.some(linha => mesmoId(linha.pf_id, pfId) && mesmoId(linha.proj_id, projId))
  }

  const atividadesVisiveis = useMemo(() => atividades.filter(item => {
    const inicio = diaIso(item.atividade_dtIniPlanejada)
    if (somenteSemana && inicio && (inicio < semanaIniIso || inicio > semanaFimIso)) return false
    if (filtroPf && !mesmoId(item.pf_id, filtroPf)) return false
    if (filtroMes && inicio.slice(0, 7) !== filtroMes) return false
    if (filtroTipo && !mesmoId(item.setorAtiv_id, filtroTipo)) return false
    if (filtroStatus && !mesmoId(item.atividadeStatus_id, filtroStatus)) return false
    return true
  }), [atividades, somenteSemana, semanaIniIso, semanaFimIso, filtroPf, filtroMes, filtroTipo, filtroStatus])

  const produtosVisiveis = useMemo(() => {
    const ids = new Set(atividadesVisiveis.map(item => String(item.prod_id)))
    return produtos.filter(item => ids.has(String(item.prod_id)))
  }, [atividadesVisiveis, produtos])

  const projetosAndamento = useMemo(
    () => projetos.filter(projeto => Number(projeto.projSituacao_id) === 2),
    [projetos],
  )

  const projetosVisiveis = useMemo(() => {
    const ids = new Set()
    atividadesVisiveis.forEach(item => {
      if (item.proj_id) ids.add(String(item.proj_id))
      const produto = produtoPorId.get(String(item.prod_id))
      if (produto && produto.proj_id) ids.add(String(produto.proj_id))
    })
    return projetos.filter(item => ids.has(String(item.proj_id)))
  }, [atividadesVisiveis, produtoPorId, projetos])

  const meses = useMemo(() => {
    const chaves = new Set()
    atividades.forEach(item => {
      const inicio = diaIso(item.atividade_dtIniPlanejada)
      if (inicio) chaves.add(inicio.slice(0, 7))
    })
    return [...chaves].sort()
  }, [atividades])

  const opcoesProjeto = useMemo(() => {
    let base = form.pf_id
      ? projetosAndamento.filter(projeto => naEquipe(form.pf_id, projeto.proj_id))
      : [...projetosAndamento]
    if (form.proj_id && !base.some(projeto => mesmoId(projeto.proj_id, form.proj_id))) {
      const atual = projetos.find(projeto => mesmoId(projeto.proj_id, form.proj_id))
      if (atual) base = [...base, atual]
    }
    return [...base].sort((a, b) => String(a.proj_nome).localeCompare(String(b.proj_nome), 'pt-BR'))
  }, [form.pf_id, form.proj_id, projetos, projetosAndamento, equipe])

  const opcoesProduto = useMemo(() => {
    const idsAndamento = new Set(projetosAndamento.map(projeto => String(projeto.proj_id)))
    let base = produtos.filter(produto => idsAndamento.has(String(produto.proj_id)))
    if (form.proj_id) {
      base = produtos.filter(produto => mesmoId(produto.proj_id, form.proj_id) && (idsAndamento.has(String(produto.proj_id)) || mesmoId(produto.prod_id, form.prod_id)))
    } else if (form.pf_id) {
      const projetosDaPessoa = new Set(
        equipe.filter(linha => mesmoId(linha.pf_id, form.pf_id)).map(linha => String(linha.proj_id)),
      )
      base = base.filter(produto => projetosDaPessoa.has(String(produto.proj_id)))
    }
    if (form.prod_id && !base.some(produto => mesmoId(produto.prod_id, form.prod_id))) {
      const atual = produtos.find(produto => mesmoId(produto.prod_id, form.prod_id))
      if (atual) base = [...base, atual]
    }
    return [...base].sort((a, b) => String(a.prod_desc).localeCompare(String(b.prod_desc), 'pt-BR'))
  }, [form.proj_id, form.pf_id, form.prod_id, produtos, projetosAndamento, equipe])

  const opcoesPessoa = useMemo(() => {
    let base = form.proj_id
      ? pessoas.filter(pessoa => naEquipe(pessoa.pf_id, form.proj_id))
      : [...pessoas]
    if (form.pf_id && !base.some(pessoa => mesmoId(pessoa.pf_id, form.pf_id))) {
      const atual = pessoas.find(pessoa => mesmoId(pessoa.pf_id, form.pf_id))
      if (atual) base = [...base, atual]
    }
    return [...base].sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR'))
  }, [form.proj_id, form.pf_id, pessoas, equipe])

  function limparDestaque() {
    setTravado(false)
    setAlvo(null)
  }

  function relacionado(card) {
    if (!alvo) return false
    if (alvo.kind === 'proj') return mesmoId(card.projId, alvo.projId)
    if (alvo.kind === 'prod') {
      return mesmoId(card.prodId, alvo.prodId) || (card.kind === 'proj' && mesmoId(card.projId, alvo.projId))
    }
    return mesmoId(card.ativId, alvo.ativId)
      || (card.kind === 'prod' && mesmoId(card.prodId, alvo.prodId))
      || (card.kind === 'proj' && mesmoId(card.projId, alvo.projId))
  }

  function aoEntrar(card) {
    if (travado) return
    setAlvo(card)
  }

  function aoSair() {
    if (travado) return
    setAlvo(null)
  }

  function aoClicarCard(event, card) {
    event.stopPropagation()
    setTravado(true)
    setAlvo(card)
  }

  useEffect(() => {
    function cliqueFora(event) {
      if (event.target.closest('.ativ-card') || event.target.closest('.ativ-modal')) return
      setTravado(false)
      setAlvo(null)
    }
    document.addEventListener('click', cliqueFora)
    return () => document.removeEventListener('click', cliqueFora)
  }, [])

  function escolherProjeto(projId) {
    setForm(prev => {
      const next = { ...prev, proj_id: projId }
      if (next.prod_id) {
        const produto = produtoPorId.get(String(next.prod_id))
        if (!produto || !mesmoId(produto.proj_id, projId)) next.prod_id = ''
      }
      if (projId && next.pf_id && !naEquipe(next.pf_id, projId)) next.pf_id = ''
      return next
    })
  }

  function escolherProduto(prodId) {
    setForm(prev => {
      if (!prodId) return { ...prev, prod_id: '' }
      const produto = produtoPorId.get(String(prodId))
      const projId = produto ? String(produto.proj_id) : prev.proj_id
      const next = { ...prev, prod_id: prodId, proj_id: projId }
      if (projId && next.pf_id && !naEquipe(next.pf_id, projId)) next.pf_id = ''
      return next
    })
  }

  function escolherPessoa(pfId) {
    setForm(prev => {
      const next = { ...prev, pf_id: pfId }
      if (!pfId) return next
      if (next.proj_id && !naEquipe(pfId, next.proj_id)) {
        next.proj_id = ''
        next.prod_id = ''
      } else if (next.prod_id) {
        const produto = produtoPorId.get(String(next.prod_id))
        if (produto && !naEquipe(pfId, produto.proj_id)) next.prod_id = ''
      }
      return next
    })
  }

  function abrirModal() {
    setAvisoForm('')
    setTarefasPendentes([])
    setForm(FORM_INICIAL)
    setModalAberto(true)
  }

  function abrirEdicao(item) {
    const produto = produtoPorId.get(String(item.prod_id))
    setAvisoForm('')
    setForm({
      atividade_id: item.atividade_id,
      atividade_nome: item.atividade_nome || '',
      proj_id: item.proj_id ? String(item.proj_id) : (produto ? String(produto.proj_id) : ''),
      prod_id: item.prod_id ? String(item.prod_id) : '',
      pf_id: item.pf_id ? String(item.pf_id) : '',
      setorAtiv_id: item.setorAtiv_id ? String(item.setorAtiv_id) : '',
      unidade_id: item.unidade_id ? String(item.unidade_id) : '',
      atividade_unidadeQtd: item.atividade_unidadeQtd ?? '',
      dtIniPlanejada: dataDeIso(item.atividade_dtIniPlanejada),
      dtFimPlanejada: dataDeIso(item.atividade_dtFimPlanejada),
      dtIniReal: dataDeIso(item.atividade_dtIniReal),
      dtFimReal: dataDeIso(item.atividade_dtFimReal),
      atividade_local: item.atividade_local || '',
      atividadeStatus_id: item.atividadeStatus_id ? String(item.atividadeStatus_id) : '1',
      atividade_coment: item.atividade_coment || '',
    })
    setModalAberto(true)
  }

  function fecharModal() {
    if (salvando) return
    setModalAberto(false)
  }

  function montarDados(origem) {
    const prodId = origem.prod_id ? Number(origem.prod_id) : null
    let projId = origem.proj_id ? Number(origem.proj_id) : null
    if (prodId) {
      const produto = produtoPorId.get(String(prodId))
      projId = produto ? Number(produto.proj_id) : projId
    }
    return {
      prodId,
      projId,
      dados: {
        atividade_nome: origem.atividade_nome == null || String(origem.atividade_nome).trim() === '' ? null : String(origem.atividade_nome).trim(),
        proj_id: projId,
        prod_id: prodId,
        pf_id: origem.pf_id ? Number(origem.pf_id) : null,
        setorAtiv_id: origem.setorAtiv_id ? Number(origem.setorAtiv_id) : null,
        unidade_id: origem.unidade_id ? Number(origem.unidade_id) : null,
        atividade_unidadeQtd: origem.atividade_unidadeQtd === '' || origem.atividade_unidadeQtd == null ? null : Number(origem.atividade_unidadeQtd),
        atividade_dtIniPlanejada: origem.dtIniPlanejada ? isoDeData(origem.dtIniPlanejada) : (diaIso(origem.atividade_dtIniPlanejada) || null),
        atividade_dtFimPlanejada: origem.dtFimPlanejada ? isoDeData(origem.dtFimPlanejada) : (diaIso(origem.atividade_dtFimPlanejada) || null),
        atividade_dtIniReal: origem.dtIniReal ? isoDeData(origem.dtIniReal) : (origem.dtIniReal === null && origem.atividade_id ? null : (diaIso(origem.atividade_dtIniReal) || null)),
        atividade_dtFimReal: origem.dtFimReal ? isoDeData(origem.dtFimReal) : (origem.dtFimReal === null && origem.atividade_id ? null : (diaIso(origem.atividade_dtFimReal) || null)),
        atividade_local: origem.atividade_local || null,
        atividade_coment: origem.atividade_coment == null || String(origem.atividade_coment).trim() === '' ? null : String(origem.atividade_coment).trim(),
        atividadeStatus_id: Number(origem.atividadeStatus_id || 1),
      },
    }
  }

  async function recarregarListas() {
    const [ativ, listaTodo] = await Promise.all([
      listar('atividade'),
      getRegs('todo', { todo_tabRef: 'atividade' }),
    ])
    setAtividades((Array.isArray(ativ) ? ativ : []).filter(item => Number(item.atividade_ativo) !== 0))
    setTodos(Array.isArray(listaTodo) ? listaTodo : [])
  }

  async function criarVazia() {
    const id = await insert('atividade', { atividadeStatus_id: 1 })
    if (!id) {
      notifyError('Não foi possível criar a atividade.')
      return
    }
    try {
      await recarregarListas()
    } catch (e) {
      notifyError('A atividade foi criada, mas a lista não atualizou.')
    }
  }

  async function gravarCampos(item, patch) {
    const junto = { ...item, ...patch }
    const { prodId, projId, dados } = montarDados(junto)
    if (prodId && !projId) {
      notifyError('Um produto precisa estar ligado a um projeto.')
      return
    }
    const ini = dados.atividade_dtIniPlanejada
    const fim = dados.atividade_dtFimPlanejada
    if (ini && fim && fim < ini) {
      notifyError('A data prevista de fim precisa ser igual ou posterior à data prevista de início.')
      return
    }
    if (dados.atividade_dtIniReal && dados.atividade_dtFimReal && dados.atividade_dtFimReal < dados.atividade_dtIniReal) {
      notifyError('A data de fim da realização precisa ser igual ou posterior à data de início da realização.')
      return
    }
    if (dados.pf_id && projId && !naEquipe(dados.pf_id, projId)) {
      notifyError('O responsável precisa estar na equipe do projeto.')
      return
    }
    const id = await update('atividade', item.atividade_id, dados)
    if (!id) {
      notifyError('Não foi possível atualizar a atividade.')
      return
    }
    try {
      setAtividades((await listar('atividade')).filter(reg => Number(reg.atividade_ativo) !== 0))
    } catch (e) {
      notifyError('A atividade foi atualizada, mas a lista não atualizou.')
    }
  }

  async function adicionarTarefa(atividadeId, nome) {
    const texto = String(nome || '').trim()
    if (!texto || !atividadeId) return false
    const id = await insert('todo', {
      todo_nome: texto,
      todo_concluida: 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(atividadeId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível adicionar a tarefa.')
      return false
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(Array.isArray(listaTodo) ? listaTodo : [])
    return true
  }

  async function concluirTarefa(tarefa) {
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: tarefa.todo_nome,
      todo_concluida: Number(tarefa.todo_concluida) ? 0 : 1,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível atualizar a tarefa.')
      return
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(Array.isArray(listaTodo) ? listaTodo : [])
  }

  async function renomearTarefa(tarefa, nome) {
    const texto = String(nome || '').trim()
    if (!texto) return false
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: texto,
      todo_concluida: Number(tarefa.todo_concluida) ? 1 : 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 1,
    })
    if (!id) {
      notifyError('Não foi possível alterar o nome do afazer.')
      return false
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(Array.isArray(listaTodo) ? listaTodo : [])
    return true
  }

  async function excluirTarefa(tarefa) {
    const id = await update('todo', tarefa.todo_id, {
      todo_nome: tarefa.todo_nome,
      todo_concluida: Number(tarefa.todo_concluida) ? 1 : 0,
      todo_tabRef: 'atividade',
      todo_tabId: Number(tarefa.todo_tabId),
      todo_ativo: 0,
    })
    if (!id) {
      notifyError('Não foi possível excluir o afazer.')
      return
    }
    const listaTodo = await getRegs('todo', { todo_tabRef: 'atividade' })
    setTodos(Array.isArray(listaTodo) ? listaTodo : [])
  }

  async function salvar(event) {
    event.preventDefault()
    const { prodId, projId, dados } = montarDados({
      ...form,
      atividade_nome: form.atividade_nome,
      proj_id: form.proj_id,
      prod_id: form.prod_id,
      dtIniPlanejada: form.dtIniPlanejada,
      dtFimPlanejada: form.dtFimPlanejada,
      dtIniReal: form.dtIniReal,
      dtFimReal: form.dtFimReal,
    })
    if (prodId && !projId) {
      setAvisoForm('Um produto precisa estar ligado a um projeto.')
      return
    }
    if (form.dtIniPlanejada && form.dtFimPlanejada && isoDeData(form.dtFimPlanejada) < isoDeData(form.dtIniPlanejada)) {
      setAvisoForm('A data prevista de fim precisa ser igual ou posterior à data prevista de início.')
      return
    }
    if (form.dtIniReal && form.dtFimReal && isoDeData(form.dtFimReal) < isoDeData(form.dtIniReal)) {
      setAvisoForm('A data de fim da realização precisa ser igual ou posterior à data de início da realização.')
      return
    }
    if (dados.pf_id && projId && !naEquipe(dados.pf_id, projId)) {
      setAvisoForm('O responsável precisa estar na equipe do projeto.')
      return
    }
    if (!form.atividadeStatus_id) {
      setAvisoForm('Informe o status.')
      return
    }

    setSalvando(true)
    setAvisoForm('')
    const editando = Boolean(form.atividade_id)
    const id = editando
      ? await update('atividade', form.atividade_id, dados)
      : await insert('atividade', dados)
    if (!id) {
      setSalvando(false)
      notifyError(editando ? 'Não foi possível atualizar a atividade.' : 'Não foi possível cadastrar a atividade.')
      return
    }
    if (!editando) {
      for (const nome of tarefasPendentes) {
        await insert('todo', {
          todo_nome: nome,
          todo_concluida: 0,
          todo_tabRef: 'atividade',
          todo_tabId: Number(id),
          todo_ativo: 1,
        })
      }
    }
    setSalvando(false)
    notifySuccess(editando ? 'Atividade atualizada.' : 'Atividade cadastrada.')
    const inicioPlanejado = dados.atividade_dtIniPlanejada
    if (inicioPlanejado && somenteSemana && (inicioPlanejado < semanaIniIso || inicioPlanejado > semanaFimIso)) {
      notifyInfo('A atividade foi salva e fica fora da semana vigente.')
    }
    setModalAberto(false)
    setTarefasPendentes([])
    try {
      await recarregarListas()
    } catch (e) {
      notifyError('A atividade foi salva, mas a lista não atualizou.')
    }
  }

  const faixa = somenteSemana
    ? `Atividades com início previsto entre ${formatarIso(semanaIniIso)} e ${formatarIso(semanaFimIso)}`
    : 'Todas as atividades, sem filtro da semana vigente'

  const unidadesOrdenadas = UNIDADES_ORDEM
    .map(id => unidades.find(item => Number(item.unidade_id) === id))
    .filter(Boolean)

  function opcoesProjetoDe(pfId, projIdAtual) {
    let base = pfId
      ? projetosAndamento.filter(projeto => naEquipe(pfId, projeto.proj_id))
      : [...projetosAndamento]
    if (projIdAtual && !base.some(projeto => mesmoId(projeto.proj_id, projIdAtual))) {
      const atual = projetos.find(projeto => mesmoId(projeto.proj_id, projIdAtual))
      if (atual) base = [...base, atual]
    }
    return base.sort((a, b) => String(a.proj_nome).localeCompare(String(b.proj_nome), 'pt-BR'))
  }

  function opcoesProdutoDe(projId, pfId, prodIdAtual) {
    const idsAndamento = new Set(projetosAndamento.map(projeto => String(projeto.proj_id)))
    let base = produtos.filter(produto => idsAndamento.has(String(produto.proj_id)))
    if (projId && idsAndamento.has(String(projId))) {
      base = base.filter(produto => mesmoId(produto.proj_id, projId))
    } else if (projId) {
      base = produtos.filter(produto => mesmoId(produto.proj_id, projId) && mesmoId(produto.prod_id, prodIdAtual))
    } else if (pfId) {
      const projetosDaPessoa = new Set(
        equipe.filter(linha => mesmoId(linha.pf_id, pfId)).map(linha => String(linha.proj_id)),
      )
      base = base.filter(produto => projetosDaPessoa.has(String(produto.proj_id)))
    }
    if (prodIdAtual && !base.some(produto => mesmoId(produto.prod_id, prodIdAtual))) {
      const atual = produtos.find(produto => mesmoId(produto.prod_id, prodIdAtual))
      if (atual) base = [...base, atual]
    }
    return base.sort((a, b) => String(a.prod_desc).localeCompare(String(b.prod_desc), 'pt-BR'))
  }

  function opcoesPessoaDe(projId, pfIdAtual) {
    let base = projId
      ? pessoas.filter(pessoa => naEquipe(pessoa.pf_id, projId))
      : [...pessoas]
    if (pfIdAtual && !base.some(pessoa => mesmoId(pessoa.pf_id, pfIdAtual))) {
      const atual = pessoas.find(pessoa => mesmoId(pessoa.pf_id, pfIdAtual))
      if (atual) base = [...base, atual]
    }
    return base.sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR'))
  }

  return (
    <div className="atividades-page">
      <header className="ativ-top">
        <div>
          <h1>Atividades</h1>
          <p>{faixa}</p>
        </div>
        <form className="ativ-filtros" onSubmit={event => event.preventDefault()}>
          <label className="ativ-campo">
            Colaborador
            <select value={filtroPf} onChange={event => { limparDestaque(); setFiltroPf(event.target.value) }}>
              <option value="">Todos</option>
              {[...pessoas].sort((a, b) => nomePessoa(a).localeCompare(nomePessoa(b), 'pt-BR')).map(pessoa => (
                <option key={pessoa.pf_id} value={pessoa.pf_id}>{nomePessoa(pessoa)}</option>
              ))}
            </select>
          </label>
          <label className="ativ-campo">
            Mês planejado
            <select value={filtroMes} onChange={event => { limparDestaque(); setFiltroMes(event.target.value) }}>
              <option value="">Todos</option>
              {meses.map(chave => (
                <option key={chave} value={chave}>{rotuloMes(chave)}</option>
              ))}
            </select>
          </label>
          <label className="ativ-campo">
            Natureza da atividade
            <select value={filtroTipo} onChange={event => { limparDestaque(); setFiltroTipo(event.target.value) }}>
              <option value="">Todas</option>
              {[...naturezas].sort((a, b) => String(a.setorAtiv_nome).localeCompare(String(b.setorAtiv_nome), 'pt-BR')).map(item => (
                <option key={item.setorAtiv_id} value={item.setorAtiv_id}>{item.setorAtiv_nome}</option>
              ))}
            </select>
          </label>
          <label className="ativ-campo">
            Status
            <select value={filtroStatus} onChange={event => { limparDestaque(); setFiltroStatus(event.target.value) }}>
              <option value="">Todos</option>
              {[...statusLista].sort((a, b) => Number(a.atividadeStatus_id) - Number(b.atividadeStatus_id)).map(item => (
                <option key={item.atividadeStatus_id} value={item.atividadeStatus_id}>{item.atividadeStatus_nome}</option>
              ))}
            </select>
          </label>
          <button type="button" className="ativ-btn ativ-btn-primario" onClick={abrirModal} disabled={carregando}>
            Cadastrar atividade
          </button>
        </form>
      </header>

      {carregando && <p className="ativ-vazio">Carregando...</p>}
      {erro && <p className="ativ-erro">{erro}</p>}

      {!carregando && !erro && (
        <div className="ativ-board">
          <section>
            <header className="ativ-coluna-head">
              <h2>Projetos</h2>
              <span className="ativ-contagem">{projetosVisiveis.length}</span>
            </header>
            <div className="ativ-lista">
              {!projetosVisiveis.length && <p className="ativ-vazio">Nenhum projeto com atividade nesta seleção.</p>}
              {projetosVisiveis.map(projeto => {
                const qtd = produtosVisiveis.filter(produto => mesmoId(produto.proj_id, projeto.proj_id)).length
                const card = { kind: 'proj', projId: projeto.proj_id }
                return (
                  <article
                    key={projeto.proj_id}
                    className={`ativ-card${relacionado(card) ? ' is-related' : ''}`}
                    onMouseEnter={() => aoEntrar(card)}
                    onMouseLeave={aoSair}
                    onClick={event => aoClicarCard(event, card)}
                  >
                    <h3>{projeto.proj_nome}</h3>
                    <p>{qtd} produto{qtd === 1 ? '' : 's'} visível{qtd === 1 ? '' : 'is'}</p>
                  </article>
                )
              })}
            </div>
          </section>

          <section>
            <header className="ativ-coluna-head">
              <h2>Produtos</h2>
              <span className="ativ-contagem">{produtosVisiveis.length}</span>
            </header>
            <div className="ativ-lista">
              {!produtosVisiveis.length && <p className="ativ-vazio">Nenhum produto com atividade nesta seleção.</p>}
              {produtosVisiveis.map(produto => {
                const projeto = projetoPorId.get(String(produto.proj_id))
                const qtd = atividadesVisiveis.filter(item => mesmoId(item.prod_id, produto.prod_id)).length
                const card = { kind: 'prod', projId: produto.proj_id, prodId: produto.prod_id }
                return (
                  <article
                    key={produto.prod_id}
                    className={`ativ-card${relacionado(card) ? ' is-related' : ''}`}
                    onMouseEnter={() => aoEntrar(card)}
                    onMouseLeave={aoSair}
                    onClick={event => aoClicarCard(event, card)}
                  >
                    <h3>{produto.prod_desc}</h3>
                    <p>{projeto ? projeto.proj_nome : ''}</p>
                    <p>{qtd} atividade{qtd === 1 ? '' : 's'} visível{qtd === 1 ? '' : 'is'}</p>
                  </article>
                )
              })}
            </div>
          </section>

          <section className="ativ-coluna-ativ">
            <header className="ativ-coluna-head">
              <div className="ativ-coluna-titulo">
                <h2>{somenteSemana ? 'Atividades da semana' : 'Todas as atividades'}</h2>
                <span className="ativ-contagem">{atividadesVisiveis.length}</span>
              </div>
              <div className="ativ-modos" role="group" aria-label="Modo da coluna de atividades">
                <button type="button" aria-pressed={somenteSemana} onClick={() => { limparDestaque(); setSomenteSemana(true) }}>
                  Ver atividades da semana
                </button>
                <button type="button" aria-pressed={!somenteSemana} onClick={() => { limparDestaque(); setSomenteSemana(false) }}>
                  Ver todas atividades
                </button>
                <button type="button" className="ativ-mais" onClick={criarVazia} aria-label="Criar atividade vazia">+</button>
              </div>
            </header>
            <div className="ativ-lista">
              {!atividadesVisiveis.length && (
                <p className="ativ-vazio">
                  {somenteSemana ? 'Nenhuma atividade da semana nesta seleção.' : 'Nenhuma atividade nesta seleção.'}
                </p>
              )}
              {atividadesVisiveis.map(item => {
                const produto = produtoPorId.get(String(item.prod_id))
                const projId = item.proj_id || (produto ? produto.proj_id : '')
                const card = { kind: 'ativ', projId, prodId: item.prod_id, ativId: item.atividade_id }
                const projetosCard = opcoesProjetoDe(item.pf_id, projId)
                const produtosCard = opcoesProdutoDe(projId, item.pf_id, item.prod_id)
                const pessoasCard = opcoesPessoaDe(projId, item.pf_id)
                const tarefasItem = todos.filter(tarefa => mesmoId(tarefa.todo_tabId, item.atividade_id) && tarefa.todo_tabRef === 'atividade')
                const natureza = naturezas.find(opcao => mesmoId(opcao.setorAtiv_id, item.setorAtiv_id))
                const statusNome = statusLista.find(status => mesmoId(status.atividadeStatus_id, item.atividadeStatus_id))
                const qtd = rotuloQuantidade(item.unidade_id, item.atividade_unidadeQtd)
                const unidade = unidadesOrdenadas.find(opcao => mesmoId(opcao.unidade_id, item.unidade_id))
                const inicio = formatarIso(item.atividade_dtIniPlanejada)
                const fim = formatarIso(item.atividade_dtFimPlanejada)
                const projeto = projetoPorId.get(String(projId))
                const pessoa = pessoas.find(registro => mesmoId(registro.pf_id, item.pf_id))
                const detalhesAberto = detalhesAbertos.has(String(item.atividade_id))
                const vinculos = [
                  projeto && projeto.proj_nome,
                  produto && produto.prod_desc,
                  pessoa && nomePessoa(pessoa),
                ].filter(Boolean)
                const badges = [
                  natureza && natureza.setorAtiv_nome,
                  qtd || (unidade && unidade.unidade_nome),
                  inicio && `Início ${inicio}`,
                  fim && `Fim ${fim}`,
                  item.atividade_local,
                  statusNome && statusNome.atividadeStatus_nome,
                ].filter(Boolean)
                return (
                  <article
                    key={item.atividade_id}
                    className={`ativ-card${relacionado(card) ? ' is-related' : ''}`}
                    onMouseEnter={() => aoEntrar(card)}
                    onMouseLeave={aoSair}
                    onClick={event => aoClicarCard(event, card)}
                  >
                    <div className="ativ-card-topo">
                      <input
                        className="ativ-nome"
                        defaultValue={item.atividade_nome || ''}
                        key={`nome-${item.atividade_id}-${item.atividade_nome || ''}`}
                        placeholder="Nome da atividade"
                        onClick={event => event.stopPropagation()}
                        onBlur={event => {
                          const texto = event.target.value
                          if (texto === (item.atividade_nome || '')) return
                          gravarCampos(item, { atividade_nome: texto })
                        }}
                      />
                      <button
                        type="button"
                        className="ativ-btn ativ-btn-secundario ativ-editar"
                        onClick={event => {
                          event.stopPropagation()
                          abrirEdicao(item)
                        }}
                      >
                        Editar
                      </button>
                    </div>
                    {detalhesAberto && (
                    <>
                    <label className="ativ-campo" onClick={event => event.stopPropagation()}>
                      Projeto
                      <select
                        value={projId || ''}
                        onChange={event => {
                          const novo = event.target.value
                          const patch = { proj_id: novo || null }
                          if (produto && !mesmoId(produto.proj_id, novo)) patch.prod_id = null
                          if (novo && item.pf_id && !naEquipe(item.pf_id, novo)) patch.pf_id = null
                          gravarCampos(item, patch)
                        }}
                      >
                        <option value="">Sem projeto</option>
                        {projetosCard.map(projeto => (
                          <option key={projeto.proj_id} value={projeto.proj_id}>{projeto.proj_nome}</option>
                        ))}
                      </select>
                    </label>
                    <label className="ativ-campo" onClick={event => event.stopPropagation()}>
                      Produto
                      <select
                        value={item.prod_id || ''}
                        onChange={event => {
                          const novo = event.target.value
                          if (!novo) {
                            gravarCampos(item, { prod_id: null })
                            return
                          }
                          const escolhido = produtoPorId.get(String(novo))
                          const patch = { prod_id: novo, proj_id: escolhido ? escolhido.proj_id : projId }
                          if (patch.proj_id && item.pf_id && !naEquipe(item.pf_id, patch.proj_id)) patch.pf_id = null
                          gravarCampos(item, patch)
                        }}
                      >
                        <option value="">Sem produto</option>
                        {produtosCard.map(opcao => (
                          <option key={opcao.prod_id} value={opcao.prod_id}>{opcao.prod_desc}</option>
                        ))}
                      </select>
                    </label>
                    <label className="ativ-campo" onClick={event => event.stopPropagation()}>
                      Responsável
                      <select
                        value={item.pf_id || ''}
                        onChange={event => gravarCampos(item, { pf_id: event.target.value || null })}
                      >
                        <option value="">Sem responsável</option>
                        {pessoasCard.map(pessoa => (
                          <option key={pessoa.pf_id} value={pessoa.pf_id}>{nomePessoa(pessoa)}</option>
                        ))}
                      </select>
                    </label>
                    </>
                    )}
                    {(vinculos.length > 0 || badges.length > 0) && (
                      <div className="ativ-meta">
                        {!detalhesAberto && vinculos.map((texto, indice) => (
                          <span key={`${item.atividade_id}-v-${indice}`} className="ativ-chip">{texto}</span>
                        ))}
                        {badges.map((texto, indice) => <span key={`${item.atividade_id}-${indice}`} className="ativ-chip">{texto}</span>)}
                      </div>
                    )}
                    <div className="ativ-card-faixa">
                      <button
                        type="button"
                        className="ativ-detalhes"
                        aria-expanded={detalhesAberto}
                        onClick={event => {
                          event.stopPropagation()
                          setDetalhesAbertos(atual => {
                            const proximo = new Set(atual)
                            const chave = String(item.atividade_id)
                            if (proximo.has(chave)) proximo.delete(chave)
                            else proximo.add(chave)
                            return proximo
                          })
                        }}
                      >
                        Ver detalhes
                      </button>
                      <ListaTarefas
                        recolhivel
                        tarefas={tarefasItem}
                        onAdicionar={nome => adicionarTarefa(item.atividade_id, nome)}
                        onConcluir={concluirTarefa}
                        onRenomear={renomearTarefa}
                        onExcluir={excluirTarefa}
                      />
                    </div>
                  </article>
                )
              })}
            </div>
          </section>
        </div>
      )}

      {modalAberto && (
        <div className="ativ-modal-fundo" onClick={fecharModal}>
          <div className="ativ-modal" role="dialog" aria-modal="true" aria-labelledby="ativ-modal-titulo" onClick={event => event.stopPropagation()}>
            <header className="ativ-modal-head">
              <h2 id="ativ-modal-titulo">{form.atividade_id ? 'Editar atividade' : 'Cadastrar atividade'}</h2>
              <button type="button" className="ativ-fechar" onClick={fecharModal} aria-label="Fechar">×</button>
            </header>
            <form className="ativ-form" onSubmit={salvar}>
              <label className="ativ-campo">
                Nome da atividade
                <input
                  type="text"
                  value={form.atividade_nome}
                  onChange={event => setForm(prev => ({ ...prev, atividade_nome: event.target.value }))}
                />
              </label>
              <label className="ativ-campo">
                Projeto
                <select value={form.proj_id} onChange={event => escolherProjeto(event.target.value)}>
                  <option value="">Sem projeto</option>
                  {opcoesProjeto.map(projeto => (
                    <option key={projeto.proj_id} value={projeto.proj_id}>{projeto.proj_nome}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Produto
                <select value={form.prod_id} onChange={event => escolherProduto(event.target.value)}>
                  <option value="">Sem produto</option>
                  {opcoesProduto.map(produto => (
                    <option key={produto.prod_id} value={produto.prod_id}>{produto.prod_desc}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Responsável
                <select value={form.pf_id} onChange={event => escolherPessoa(event.target.value)}>
                  <option value="">Sem responsável</option>
                  {opcoesPessoa.map(pessoa => (
                    <option key={pessoa.pf_id} value={pessoa.pf_id}>{nomePessoa(pessoa)}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Natureza da atividade
                <select
                  value={form.setorAtiv_id}
                  onChange={event => setForm(prev => ({ ...prev, setorAtiv_id: event.target.value }))}
                >
                  <option value="">Selecione</option>
                  {[...naturezas].sort((a, b) => String(a.setorAtiv_nome).localeCompare(String(b.setorAtiv_nome), 'pt-BR')).map(item => (
                    <option key={item.setorAtiv_id} value={item.setorAtiv_id}>{item.setorAtiv_nome}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Unidade
                <select
                  value={form.unidade_id}
                  onChange={event => setForm(prev => ({ ...prev, unidade_id: event.target.value }))}
                >
                  <option value="">Selecione</option>
                  {unidadesOrdenadas.map(item => (
                    <option key={item.unidade_id} value={item.unidade_id}>{item.unidade_nome}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                {ROTULO_QTD[Number(form.unidade_id)] || 'Quantidade'}
                <input
                  type="number"
                  min="1"
                  step="1"
                  value={form.atividade_unidadeQtd}
                  onChange={event => setForm(prev => ({ ...prev, atividade_unidadeQtd: event.target.value }))}
                />
              </label>
              <div className="ativ-datas">
                <label className="ativ-campo">
                  Data prevista para fim
                  <DatePicker
                    selected={form.dtFimPlanejada}
                    onChange={data => setForm(prev => ({ ...prev, dtFimPlanejada: data }))}
                    locale="pt-BR"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    placeholderText="dd/mm/aaaa"
                  />
                </label>
              </div>
              <label className="ativ-campo">
                Local
                <select
                  value={form.atividade_local}
                  onChange={event => setForm(prev => ({ ...prev, atividade_local: event.target.value }))}
                >
                  <option value="">Sem local</option>
                  {LOCAIS.map(local => (
                    <option key={local} value={local}>{local}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Status
                <select
                  value={form.atividadeStatus_id}
                  onChange={event => setForm(prev => ({ ...prev, atividadeStatus_id: event.target.value }))}
                  required
                >
                  {statusLista.map(item => (
                    <option key={item.atividadeStatus_id} value={item.atividadeStatus_id}>{item.atividadeStatus_nome}</option>
                  ))}
                </select>
              </label>
              <label className="ativ-campo">
                Comentário
                <textarea
                  rows="3"
                  value={form.atividade_coment}
                  onChange={event => setForm(prev => ({ ...prev, atividade_coment: event.target.value }))}
                />
              </label>
              <ListaTarefas
                tarefas={form.atividade_id ? todos.filter(tarefa => mesmoId(tarefa.todo_tabId, form.atividade_id) && tarefa.todo_tabRef === 'atividade') : []}
                pendentes={form.atividade_id ? [] : tarefasPendentes}
                onAdicionar={async nome => {
                  if (form.atividade_id) return adicionarTarefa(form.atividade_id, nome)
                  setTarefasPendentes(lista => [...lista, nome])
                  return true
                }}
                onConcluir={concluirTarefa}
                onRenomear={renomearTarefa}
                onExcluir={excluirTarefa}
                onRenomearPendente={(indice, texto) => {
                  setTarefasPendentes(lista => lista.map((item, i) => (i === indice ? texto : item)))
                }}
                onExcluirPendente={indice => {
                  setTarefasPendentes(lista => lista.filter((_, i) => i !== indice))
                }}
              />
              {avisoForm && <p className="ativ-aviso">{avisoForm}</p>}
              <footer className="ativ-acoes">
                <button type="button" className="ativ-btn ativ-btn-secundario" onClick={fecharModal}>Cancelar</button>
                <button type="submit" className="ativ-btn ativ-btn-primario" disabled={salvando}>
                  {salvando ? 'Salvando...' : 'Salvar'}
                </button>
              </footer>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
